export const MENU_PROFILING_CATEGORY = 'app/MenuProfiling/MENU_PROFILING_CATEGORY';
export const MENU_PROFILING_CATEGORY_SUCCESS = 'app/MenuProfiling/MENU_PROFILING_CATEGORY_SUCCESS';
export const MENU_PROFILING_CATEGORY_FAILURE = 'app/MenuProfiling/MENU_PROFILING_CATEGORY_FAILURE';

export const MENU_PROFILING_ITEMS= 'app/MenuProfiling/MENU_PROFILING_ITEMS';
export const MENU_PROFILING_ITEMS_SUCCESS= 'app/MenuProfiling/MENU_PROFILING_ITEMS_SUCCESS';
export const MENU_PROFILING_ITEMS_FAILURE= 'app/MenuProfiling/MENU_PROFILING_ITEMS_FAILURE';
